// Sync envelopes — INV-07 / 05 §3. Additive changes only within a schema_version; breaking → bump + upcaster.
import { z } from 'zod';
import { dateSchema, uuidSchema } from './common.js';
export const eventEnvelopeSchema = z.object({
    eventId: uuidSchema,
    propertyId: uuidSchema,
    /** open set — modules add streams additively (reservation, stay, guest, folio, cashier, night_audit, housekeeping, maintenance, config, identity, audit, system) */
    stream: z.string().min(1).max(40),
    aggregateId: uuidSchema,
    sequence: z.number().int().nonnegative(),
    eventType: z.string().min(1),
    schemaVersion: z.number().int().positive(),
    occurredAt: z.iso.datetime(),
    businessDate: dateSchema,
    causationId: uuidSchema.optional(),
    correlationId: uuidSchema.optional(),
    payload: z.record(z.string(), z.unknown()),
});
export const eventBatchSchema = z.object({
    nodeId: uuidSchema,
    nodeVersion: z.string(),
    events: z.array(eventEnvelopeSchema).max(200),
});
export const eventBatchAckSchema = z.object({
    ackedUpToSequence: z.number().int().nonnegative(),
    serverTime: z.iso.datetime(),
    nextPollHintSeconds: z.number().int().positive().optional(),
    minSupportedNodeVersion: z.string().optional(),
});
export const commandEnvelopeSchema = z.object({
    commandId: uuidSchema,
    propertyId: uuidSchema,
    sequence: z.number().int().nonnegative(),
    commandType: z.string().min(1),
    schemaVersion: z.number().int().positive(),
    payload: z.record(z.string(), z.unknown()),
    /** base64 Ed25519 signature over the canonical JSON of the fields above (05 §3.3) */
    signature: z.string().min(1),
});
//# sourceMappingURL=sync.js.map